import { render, staticRenderFns } from "./vChooseRetailer.vue?vue&type=template&id=77dbb04a&"
import script from "./vChooseRetailer.vue?vue&type=script&lang=js&"
export * from "./vChooseRetailer.vue?vue&type=script&lang=js&"
import style0 from "./vChooseRetailer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports